module.exports = __webpack_public_path__ + "img/logo.b765bb1d.svg";